import { v4 as uuid } from 'uuid';

export const replaceIframesWithSpans = (htmlContent: string) => {
  // If the string contains no iframe, return it directly
  if (!htmlContent.includes('<iframe')) {
    return {
      replacements: [],
      modifiedHtml: htmlContent,
    };
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const iFrames = doc.querySelectorAll('iframe');
  const replacements = [] as Array<{ iframe: HTMLIFrameElement; spanId: string }>;

  iFrames.forEach((iframe) => {
    const div = doc.createElement('span');
    const uniqueId = uuid();
    const id = `replaced-iframe-${uniqueId}`;

    div.id = id;
    div.style.cssText = iframe.style.cssText;

    iframe.parentNode?.replaceChild(div, iframe);

    replacements.push({
      iframe,
      spanId: id,
    });
  });

  const modifiedHtml = doc.body.innerHTML;

  return {
    replacements,
    modifiedHtml,
  };
};
